<!--
 * @Description: 学期教学计划
 * @Author: PF
 * @Date: 2023-12-21 11:00:52
 * @LastEditors: PF
 * @LastEditTime: 2023-12-21 17:05:36
-->

<template>
  <!-- <h1>学期教学计划列表</h1> -->
  <div class="tan-chuang">
    <div class="list-page">
      <el-dialog class="wp90 h800" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Edit />
            </el-icon>
            <span class="header-title">学期教学计划</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-container>
          <el-header>
            <!-- 搜索区域 -->
            <el-form class="search-box" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="学期" v-model="xqid" clearable filterable @change="initBanJi();bindTable()">
                  <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="班级" v-model="bjid" clearable filterable @change="initKeCheng();bindTable()">
                  <el-option v-for="item in bjData" :key="item.bjid" :label="item.bjmc" :value="item.bjid"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="课程" v-model="kcid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in kcData" :key="item.id" :label="item.kcmc" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main>
            <el-table :data="tableData" height="100%" border stripe v-loading="loading">
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <el-table-column label="学期" prop="xqmc" align="center" show-overflow-tooltip />
              <el-table-column label="班级" prop="bjmc" align="center" show-overflow-tooltip />
              <el-table-column label="课程" prop="kcmc" align="center" show-overflow-tooltip />
              <el-table-column label="操作" width="120" fixed="right" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-button link type="success" @click="openSheZhi=true;row={ dbgzid: xqid, kcid: scope.row.kcid, bjid: scope.row.bjid }">设置</el-button>
                  <el-button link type="primary" @click="openDetail=true;row={ dbgzid: xqid, kcid: scope.row.kcid, bjid: scope.row.bjid }">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-container>
      </el-dialog>
    </div>
  </div>
  <shezhi v-if="openSheZhi" v-model:openSheZhi="openSheZhi" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { actionPost, loadSelect, homeCloseWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo'
import shezhi from './shezhi.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])



const bjid = ref()
const bjData = ref([])
const initBanJi = () => {
  const o = {
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/jiaoshixueqikebiaobanjikecheng',
    data: { dbgzid: xqid.value }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      bjData.value = res.data
      bjid.value = res.data ? res.data[0].bjid : ''
      initKeCheng()
    } else {
      warningPrompt(res.message)
    }
  })
}

const kcid = ref()
const kcData = ref([])
const initKeCheng = () => {
  const data = bjData.value.find(item => item.bjid === bjid.value)
  kcData.value = data.listKeCheng
  kcid.value = kcData.value ? kcData.value[0].id : ''
  bindTable()
}

// 列表
const tableData = ref()
const loading = ref(false)
const bindTable = async () => {
  loading.value = true
  const o = {
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/jiaoshixueqikecheng',
    data: { xqid: xqid.value, kcid: kcid.value, bjid: bjid.value }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      tableData.value = res.data
      loading.value = false
    } else {
      loading.value = false
      warningPrompt(res.message)
    }
  })
}
const xqid = ref()
const xqData = ref()
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'xueqijiaoxuejihua') {
      openList.value = true
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              xqid.value = element.id
              initBanJi()
            }
          })
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 弹窗
const openSheZhi = ref(false)
const openDetail = ref(false)
</script>
